import {
  type ApiRequest,
  type ApiResponseSingle,
  properCallApi
} from '@/api/tenantClient';

export const infoFormResponseQueryKey = 'registration.infoFormResponseList';
export const infoFormResponseQueryKeyWithStupidItem = 'registration.infoFormResponseListWithStupidItem';

export interface InfoFormResponse {
  id: number
  response: Record<string, any>
  eventId: string
  ownerId: number
  ownerType: 'Registration'
  infoFormId: number
}

export enum InfoFormType {
  PERSONAL = 'personal',
  ADDITIONAL = 'additional'
}

export interface InfoFormResponseQueryRequest {
  formId?: number
  registrationId: number
  type: InfoFormType
}

export function loadRegistrationInfoFormResponse(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: InfoFormResponseQueryRequest
  ): Promise<ApiResponseSingle<InfoFormResponse>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/info_form_responses/' + params.registrationId.toString();
    request.endpoint.query = {
      form_id: params.formId,
      type: params.type
    };
    return await properCallApi<ApiResponseSingle<InfoFormResponse>>(request);
  };
}
